module.exports = __webpack_public_path__ + "img/email.517983a6.svg";